import { faLink, faLinkSlash, faUser } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Box, Button, Text, UserProfileImage,
} from '@domain-group/suit-theme'

type IntegrationBannerProps = {
  integrated: boolean,
  integratedBy?: {
    name: string,
    image_url?: string,
  },
}

const IntegrationBanner = (props: IntegrationBannerProps) => {
  const { integrated, integratedBy } = props

  return (
    <Box
      flexDirection="column"
      alignItems="center"
      padding="large"
      lineHeight="1.3"
      marginBottom="large"
      variant="white"
    >
      <Box
        flexDirection="row"
        borderBottom={integrated ? '1px solid' : 'none'}
        borderColor="lineColor"
        paddingBottom={integrated ? 'small' : 'none'}
      >
        <Box flexDirection="column">
          <Text fontSize="medium">
            Canva Integration
          </Text>
          <Text fontSize="xsmall" color="bodyFontLightColor" marginTop="small">
            Link brand templates to services, products, and agencies. Once linked, agency users can build artwork inside
            Canva and publish straight back to a Realhub order.
          </Text>
        </Box>

        <Box marginLeft="auto" width="auto" paddingLeft="large" padding="small">
          {integrated ? (
            <Button
              buttonStyle="secondaryDestroy"
              icon={<FontAwesomeIcon icon={faLinkSlash} />}
              size="small"
              style={{ whiteSpace: 'nowrap' }}
            >
              Disconnect Canva
            </Button>
          ) : (
            <Button
              buttonStyle="primaryEdit"
              icon={<FontAwesomeIcon icon={faLink} />}
              size="small"
              style={{ whiteSpace: 'nowrap' }}
            >
              Connect to Canva
            </Button>
            // <ButtonWithOauth
            //   authProviderKey="canva"
            //   buttonStyle="primaryCreate"
            //   queryParams={{
            //     redirect: window.location.href,
            //   }}
            //   size="medium"
            // >
            //   Connect to Canva
            // </ButtonWithOauth>
          )}
        </Box>
      </Box>

      {integrated && integratedBy && (
        <Box flexDirection="row" marginTop="large" variant="light">
          <Box maxWidth="40%" overflow="hidden" justifyContent="flex-end">
            <Box marginRight="medium" width="auto">
              <UserProfileImage imageUrl={integratedBy?.image_url}>
                <FontAwesomeIcon icon={faUser} />
              </UserProfileImage>
            </Box>

            <Box flexDirection="column">
              <Text color="bodyFontLightColor" fontSize="xsmall">Linked by</Text>
              <Text fontSize="small" marginTop="small">
                {integratedBy?.name}
              </Text>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default IntegrationBanner
